import React from 'react';
import { useTranslation } from 'react-i18next';

const LoginHeader: React.FC = () => {
  const { t, i18n } = useTranslation('login');

  const toggleLang = () => {
    const newLang = i18n.language === 'en' ? 'jp' : 'en';
    i18n.changeLanguage(newLang);
  }

  return (
    <header>
      <div className="container">
        <div className="float-left">
          <h1 className="m-0 text-[32px] leading-[51px] font-bold">Verification Management Tool <span className="text-xl">for TRUSTDOCK</span></h1>
        </div>
      </div>
    </header>
  );
};

export default LoginHeader;